import React from 'react';
import { Form } from 'semantic-ui-react';
import BoothsSelector from '../../widgets/booths-selector';
import { Label } from './label';
import { setupField } from '../utils/form-utils';
import { FieldError } from './field-error';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function BoothsField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline>
      <Label>Booths</Label>
      <BoothsSelector
        {...field}
        multiple
        value={field.value || []}
        onChange={handleChange}
        onBlur={handleBlur}
        error={error}
      />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
